module.exports = __webpack_public_path__ + "img/80A.34182fb7.png";